module.exports = __webpack_public_path__ + "assets/img/qr-logo.da99a4d7.png";